module.exports = {"330212001":"下应街道","330212002":"钟公庙街道","330212004":"梅墟街道","330212005":"中河街道","330212006":"首南街道","330212007":"潘火街道","330212008":"百丈街道","330212009":"东胜街道","330212010":"明楼街道","330212011":"白鹤街道","330212012":"东柳街道","330212013":"东郊街道","330212014":"福明街道","330212015":"新明街道","330212100":"瞻岐镇","330212101":"咸祥镇","330212102":"塘溪镇","330212103":"东钱湖镇","330212104":"东吴镇","330212105":"五乡镇","330212106":"邱隘镇","330212108":"云龙镇","330212109":"横溪镇","330212110":"姜山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330212.json
// module id = 960
// module chunks = 0